import apiClient from "../../../../../services/apiClient";



// Функция для преобразования данных из модели сервера в форму
const prepareDataFromServer = (serverData) => {
  return {
    // Основная информация
    type: serverData.type || 'Дошкільний підрозділ',
    ownership: serverData.property || 'Комунальний',
    specialization: serverData.specialization || 'Без спеціалізації',
    extra: serverData.existence?.join(', ') || 'Музичний зал',
    
    // Контакты
    address: serverData.contacts?.address?.string || 'м. Київ, вул. Лесі Українки, 91А',
    district: serverData.contacts?.address?.district || 'Святошинський',
    phone: serverData.contacts?.phones?.[0] || '(098) 560-60-88',
    email: serverData.contacts?.email || 'dytyachysadochok@osvita.kyivcity.ua',
    site: serverData.contacts?.site || 'https://osvita.kyivcity.gov.ua/dytyachysadochok',
    
    // Режим работы
    workModes: serverData.workingHours ? [
      {
        mode: serverData.workingHours.type || 'Повний 12-годинний день',
        start: serverData.workingHours.timeFrom || '7:00',
        end: serverData.workingHours.timeTo || '19:00'
      }
    ] : [
      { mode: 'Повний 12-годинний день', start: '7:00', end: '19:00' },
      { mode: 'Скорочений 10,5-годинний день', start: '8:00', end: '18:00' }
    ],
    
    workDays: {
      monday: serverData.workingHours?.daysOfWeek?.includes('monday') ?? true,
      tuesday: serverData.workingHours?.daysOfWeek?.includes('tuesday') ?? true,
      wednesday: serverData.workingHours?.daysOfWeek?.includes('wednesday') ?? true,
      thursday: serverData.workingHours?.daysOfWeek?.includes('thursday') ?? true,
      friday: serverData.workingHours?.daysOfWeek?.includes('friday') ?? true,
      saturday: serverData.workingHours?.daysOfWeek?.includes('saturday') ?? true,
      sunday: serverData.workingHours?.daysOfWeek?.includes('sunday') ?? true
    },
    
    worksOnHolidays: serverData.workingHours?.workAtHolidays ?? true,
    
    // Руководитель
    manager: serverData.head ? 
      `${serverData.head.firstName} ${serverData.head.lastName || ''}`.trim() 
      : 'Григорович Марія Василівна'
  };
};

// Функция для преобразования данных формы в модель сервера
const prepareDataForServer = (formData) => {
  const workDaysArray = Object.entries(formData.workDays)
    .filter(([_, value]) => value)
    .map(([key]) => key);

  return {
    // Основная информация
    type: formData.type,
    property: formData.ownership,
    specialization: formData.specialization,
    existence: formData.extra ? formData.extra.split(',').map(item => item.trim()) : [],
    
    // Контакты
    contacts: {
      address: {
        string: formData.address,
        district: formData.district
      },
      phones: [formData.phone],
      email: formData.email,
      site: formData.site
    },
    
    // Режим работы (берем первый режим, так как в модели один режим)
    workingHours: {
      type: formData.workModes[0]?.mode || 'Повний 12-годинний день',
      timeFrom: formData.workModes[0]?.start || '7:00',
      timeTo: formData.workModes[0]?.end || '19:00',
      daysOfWeek: workDaysArray,
      workAtHolidays: formData.worksOnHolidays
    },
    
    // Руководитель (разбиваем ФИО)
    head: {
      firstName: formData.manager.split(' ')[1] || '', // Имя
      lastName: formData.manager.split(' ')[0] || ''   // Фамилия
    }
  };
};


const loadPassportData = async (kg_id) => {

    const url = `kindergartens/${kg_id}`;

    const result = await apiClient.get(url);

    if(!result.data || ( result.data.length < 1 ) ) return null;

    return prepareDataFromServer(result.data[0]);
}

const savePassportData = async ({kg_id, data})=>{

    if(!data) return null;
    
    const url = `kindergartens/${kg_id}/main_info`;

    const result = await apiClient.put(url, prepareDataForServer(data));

    return result || null;

}

export { loadPassportData, savePassportData};